import { render } from "./CometChatMessageReactions.vue?vue&type=template&id=55b1c3c6&scoped=true"
import script from "./CometChatMessageReactions.vue?vue&type=script&lang=js"
export * from "./CometChatMessageReactions.vue?vue&type=script&lang=js"

import "./CometChatMessageReactions.vue?vue&type=style&index=0&id=55b1c3c6&lang=css"
import "./CometChatMessageReactions.vue?vue&type=style&index=1&id=55b1c3c6&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b1c3c6"]])

export default __exports__